import { PageInnerLayout } from "components/pageInnerLayout";
import { WidgetCard } from "../../../../components/widgets/WidgetCard";
import { useGetWidgetTypesData } from "hooks/widgets";

export const WidgetMaster = () => {
    const {data} = useGetWidgetTypesData()
    const responseData = data?.data?.items ?? [];
    return (
        <PageInnerLayout title="Widget Master" listing>
            <div className="h-[calc(100vh-200px)] overflow-y-auto">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 items-stretch">
                    {/* {widgetLibrary.map((widget) => (
                        <WidgetCard
                            key={widget.widget_id}
                            id={widget.widget_id}
                            name={widget.widget_name}
                            previewImage={widget.image_preview}
                        />
                    ))} */}
                    {responseData.map((widget) => (
                        <WidgetCard
                            key={widget.id}
                            id={widget.id}
                            name={widget.name}
                            previewImage={widget.image}
                        />
                    ))}
                </div>
            </div>
        </PageInnerLayout>
    );
};